// app/(main)/layout.tsx

import Footer from "../components/layouts/common/Footer";
import Header from "../components/layouts/main/Header";



export default function MainLayout({
    children,
}: {
    children: React.ReactNode;
}) {


    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Header />

            <main className="flex-1">
                {children}
            </main>

            <Footer />
            {/* Décallage uniquement sur mobile pour compenser la bottom bar */}
            <div className="h-18 md:h-0" />
        </div>
    );
}